import React from 'react';

import cn from 'classnames';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import bem from 'client/services/bem';
import {useAppMedia} from 'client/services/hooks';

import Breadcrumbs from 'client/components/common/breadcrumbs';

import cssModule from './base-page-layout.module.scss';

const b = bem('base-page-layout', {cssModule});

function BasePageLayout(props) {
  const {
    className = '',
    isUserLogged = false,
    isUserNotAdmin = false,
    nobreadcrumbs = false,
    isWinning = false,
    style = {},
    hasSidebar,
    children = '',
    breadcrumbs = [],
    footer = null,
  } = props;
  const {isTablet} = useAppMedia();

  const classNames = cn(
    b({
      logged: isUserLogged,
      auth: !isUserLogged,
      user: isUserNotAdmin,
      winning: isUserNotAdmin && isWinning,
      'no-sidebar': !hasSidebar,
    }),
    className,
  );

  return (
    <div style={style}>
      <div className={classNames}>
        <div className={b('inner')}>
          {isUserLogged && !isTablet && breadcrumbs.length ? (
            <div>
              <div className={b('breadcrumbs')}>{!nobreadcrumbs && <Breadcrumbs links={breadcrumbs} />}</div>
            </div>
          ) : null}
          <div>{children}</div>
        </div>
      </div>
      {footer}
    </div>
  );
}

BasePageLayout.propTypes = {
  className: PropTypes.string,
  breadcrumbs: PropTypes.array,
  nobreadcrumbs: PropTypes.bool,
  footer: PropTypes.node,
  style: PropTypes.object,
  isUserLogged: PropTypes.bool,
  isUserNotAdmin: PropTypes.bool,
  children: PropTypes.node,
  hasSidebar: PropTypes.bool.isRequired,
};

export default connect(({breadcrumbs}) => ({
  breadcrumbs: breadcrumbs.payload,
}))(BasePageLayout);
